<template>
  <div>
    <el-dialog
      v-model="dialogStatus"
      :close-on-click-modal="false"
      :title="title"
      @close="close"
      width="50%"
      append-to-body
    >
      <el-form
        :model="form"
        ref="form"
        :rules="rules"
        label-position="left"
        label-width="100px"
      >
        <el-form-item label="角色名称" prop="roleName">
          <el-input v-model="form.roleName"></el-input>
        </el-form-item>
      </el-form>

      <div>
        <div>拥有权限：</div>
        <el-tree
          node-key="menuId"
          :data="treeData"
          :props="defaultProps"
          :default-checked-keys="oldSelect"
          show-checkbox
          @check="onCheck"
        >
        </el-tree>
      </div>

      <div style="text-align: right">
        <el-button @click="close" >取消</el-button>
        <el-button
          @click="submit"
          type="primary"

          :loading="submitLoading"
          >保存</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  sysUserRoleMenuList,
  addSysUserRole,
  updateSysUserRole,
  sysUserRoleRoleMenuList
} from "@/api/jurisdiction/role/index";

const form = {
  roleName: undefined,
};
export default {
  props: {
    title: String
  },
  data() {
    return {
      dialogStatus: false,
      submitLoading: false,
      form: Object.assign({}, form),
      rules: {
        roleName: [{ required: true, message: "请输入角色名", trigger: "blur" }],
      },
      dynamicTags: undefined,
      inputVisible: false,
      inputValue: "",
      dspSlotData: undefined,
      dspData: undefined,
      brandData: undefined,
      model: [],
      header: {},
      checkAll: false,
      menuIdList: [],
      treeData: [],
      defaultProps: {
        children: 'children',
        label: 'menuName'
      },
      oldSelect: []
    };
  },
  created() { },
  mounted() { },
  watch: {
    "oldSelect": {
      handler(oldVal) {
        if (oldVal.length != 0) {
          this.form.menuIdList = oldVal
        }
      }
    }
  },
  computed: {},
  inject: ['init'],
  methods: {
    show(data) {
      sysUserRoleMenuList().then(res => {
        this.treeData = res.data
      })
      if (data) {
        this.form = Object.assign({}, data);
        sysUserRoleRoleMenuList({ roleId: this.form.roleId }).then(res => {
          const oldSelect = []
          res.data.forEach(index => {
            // if (!this.oldSelect.includes(index.menuId)) {
            //   oldSelect.push(index?.menuId)
            // }
            index.children.forEach(i2 => {
              if (!this.oldSelect.includes(i2)) {
                oldSelect.push(i2?.menuId)
              }
            })
          })
          this.oldSelect = oldSelect
        })
      } else {
        this.oldSelect = []
      }
      this.dialogStatus = true;

    },
    close() {
      this.reset();
      this.dialogStatus = false;
    },
    reset() {
      this.form = Object.assign({}, form);
      this.$refs.form.resetFields();
    },
    onChange(val) {
      sysUserRoleMenuList({ roleId: val }).then(res => {
        this.treeData = res.data
      })
    },
    submit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.treeData.forEach(index => {
            index.children.forEach(i2 => {
              if (this.form.menuIdList && this.form.menuIdList.includes(i2.menuId)) {
                this.form.menuIdList.push(index.menuId)
                this.form.menuIdList = [...new Set(this.form.menuIdList)]
              }
            })
          })
          let newArr = []
          this.menuIdList.forEach(index => {
            if (!newArr.includes(index)) {
              newArr.push(index)
            }
          })
          if (newArr.length == 0) {
            newArr = this.form.menuIdList
          }
          this.form.menuIdList = newArr
          if (this.title === '修改角色信息编辑') {
            this.updateSysUserRole(this.form);
          } else {
            this.addSysUserRole(this.form)
          }
        }
      });
    },
    onCheck(A, checkedNodes, C, D) {
      let arr = []
      checkedNodes.checkedKeys.forEach(index => {
        arr.push(index)
      })
      if (checkedNodes.halfCheckedKeys.length !== 0) {
        checkedNodes.halfCheckedKeys.forEach(index => {
          arr.push(index)
        })
      }
      this.menuIdList = arr
    },
    addSysUserRole(form) {
      this.submitLoading = true;
      addSysUserRole(form)
        .then((res) => {
          if (res.code === 200) {
            this.$message.success("新增成功");
            this.close();
            this.init()
          }
        })
        .finally(() => {
          this.submitLoading = false;
        });
    },
    updateSysUserRole(form) {
      this.submitLoading = true;
      updateSysUserRole(form)
        .then((res) => {
          if (res.code === 200) {
            this.$message.success("编辑成功");
            this.close();
            this.init()
          }
        })
        .finally(() => {
          this.submitLoading = false;
        });
    },

    selectData() {
      let dsp = { dspId: this.form.dspId };
      selectData(dsp).then((res) => {
        if (res.code === 200) {
          this.dspSlotData = res.data;
        }
      });
    },
    onSuccess(res) {
      if (res.code === 200) {
        this.form.testUrl = res.data[0] || ''
      }
    },
    showInput() {
      this.inputVisible = true;
      // this.$nextTick((_) => {
      //   this.$refs.saveTagInput.$refs.input.focus();
      // });
    },
  },
};
</script>

<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 15px;
}

.form-label {
  display: block;
  line-height: 20px;
}

.form-item__label {
  line-height: 20px;
  text-align: center;
}

.el-tag + .el-tag {
  margin-left: 10px;
}

.button-new-tag {
  margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}

.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}

// /deep/ .el-upload {
//   border: 1px dashed #d9d9d9;
//   border-radius: 6px;
//   cursor: pointer;
//   position: relative;
//   overflow: hidden;
// }
// /deep/ .el-upload:hover {
//   border-color: #409eff;
// }
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 150px;
  height: 150px;
  line-height: 150px;
  text-align: center;
}

.avatar {
  width: 150px;
  height: 150px;
  display: block;
}
</style>
